import BaseComponent from "../../../../baseComponent.js";

export default class Header extends BaseComponent {
  handleMouseDown(e) {
    e.preventDefault();
    e.stopPropagation();
    if ($(e.currentTarget).hasClass("rotate180")) {
      $(e.currentTarget).removeClass("rotate180");
      $(".function-detail__content").stop().slideDown();
    } else {
      $(e.currentTarget).addClass("rotate180");
      $(".function-detail__content").stop().slideUp();
    }
    this.props.toggleContent();
  }

  render() {
    var spans = [];
    var key = 0;
    var toggleClass = "";
    var argIndex = this.props.argIndex > this.props.function.params.length - 1 ?
    this.props.function.params.length - 1 : this.props.argIndex;
    spans.push(<div key={key++}>{this.props.function.name}</div>);
    spans.push(<div className="fnp" key={key++}>(</div>);

    for (var i = 0; i < this.props.function.params.length; i++) {
      var className = "";
      var param = this.props.function.params[i];

      if (i === argIndex) className = "arg-active";
      if (i !== 0) spans.push(
        <div className="fnc" key={key++}>,</div>);

      if (param.optional && param.repeatable) {
        spans.push(
          <div key={key++} className={className}>[ {param.name}</div>);
        spans.push(
          <div className={className + " fnc"} key={key++}>,</div>);
        spans.push(
          <div key={key++} className={className}>... ]</div>);
      } else if (param.optional) {
        spans.push(
          <div key={key++} className={className}>[{param.name}]</div>);
      } else {
        spans.push(
          <div key={key++} className={className}>{param.name}</div>);
      }
    }
    spans.push(<div className="fnp" key={key}>)</div>);

    if (this.props.minimized) {
      toggleClass = "rotate180";
    }

    return (
      <div className="function-detail__header">
        <div className="function-example">
          {spans}
        </div>
        <div className="function-actions noselect">
          <i className={"material-icons " + toggleClass}
             onMouseDown={this.handleMouseDown}>keyboard_arrow_up</i>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/analytic-studio/spreadsheet/functions/detail/hearder.jsx